<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="feeDetails">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลค่าธรรมเนียม</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right"  class="mr-1" @click="onPressedCalculate()" v-if="visibilityCalculateButton">ประมวณผล</vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveAddFeeDetail()">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th >#</vs-th>
              <vs-th >วันที่</vs-th>
              <vs-th >ประเภท</vs-th>
              <vs-th >จำนวน</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะประมวลผล</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.feeDateLocalTh }}</vs-td>
                <vs-td>{{ row.feeTypeName }}</vs-td>
                <vs-td class="text-right">{{ row.amount | numberFormat }}</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.processed ? 'success' : 'warning'">{{ row.processed ? 'ประมวลผลแล้ว' : 'รอประมวลผล' }}</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end" v-if="visibilityFeeAction(row)">
                    <vx-tooltip text="แก้ไขข้อมูลค่าธรรมเนียม">
                      <vs-button  class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit" @click="onPressedActiveUpdateFeeDetail(row)"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูลค่าธรรมเนียม">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelFeeDetail(row.id)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup
      :active.sync="feeDetailModal.active"
      :title="feeDetailModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }" >
                <label class="text-sm">วันที่*</label>
                <flat-pickr :config="configDateFeeDetail" class="w-full" v-model="feeDetailModal.feeDate"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }"  v-slot="{ errors }" >
                <label class="text-sm">จำนวน*</label>
                <vs-input type="number" class="w-full" v-model="feeDetailModal.amount"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="ประเภท" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">ประเภท*</label>
                <v-select v-model="feeDetailModal.feeType" :clearable="false" :options="feeTypesOptions" :reduce="res => res.value" name="feeType" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="หมายเหตุ" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">หมายเหตุ*</label>
                <vs-textarea  v-model="feeDetailModal.remark" rows="5"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptFeeDetailModel">บันทึก</vs-button>
        <vs-button color="danger" @click="feeDetailModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapGetters} from "vuex";
import {visibility} from "tailwindcss/lib/plugins";
import vSelect from "vue-select";
import moment from "moment";
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IFeeType} from "@/constants/interface";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'FeeInfoTab',
  components: {
    vSelect,
    Divider,
    flatPickr
  },
  data() {
    return {
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      feeDetailModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลค่าธรรมเนียม',
        id: null,
        feeDate: moment().format('DD-MM-YYYY'),
        feeType: IFeeType.debtCollectionFeeCustom,
        amount: 0,
        remark: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      feeTypesOptions :'Master/feeTypesOptions',
    }),
    ...mapAccountingFields(['contractDetail','contractDetailFeeDetails']),
    configDateFeeDetail(){
      const vm = this
      let minDate = null
      let maxDate = null
      let lastUpdateDate = null

      if(vm.contractDetail) {
        const { loan } = vm.contractDetail
        if(loan){
          const { lastUpdate } = loan
          lastUpdateDate = moment(lastUpdate).add(1, 'days')
          minDate = lastUpdateDate.format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    visibilityCalculateButton() {
      if (!this.contractDetailFeeDetails) return false;
      const unProcessFeeDetails = this.contractDetailFeeDetails.filter(({processed}) => !processed);
      return unProcessFeeDetails.length > 0;
    },
    feeDetails() {
      if (!this.contractDetailFeeDetails) return null;
      return [...this.contractDetailFeeDetails]
        .sort(({ feeDate: aFeeDate, createdAt: aCreatedAt }, { feeDate: bFeeDate, createdAt: bCreatedAt }) => {
          const feeDateDiff = new Date(bFeeDate) - new Date(aFeeDate);
          if (feeDateDiff !== 0) {
            return feeDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((feeDetail) => {
          const {
              id,
              feeDate,
              feeType,
              amount,
              feeTypeName,
              createdAtLocalTh,
              createByFullName,
              feeDateLocalTh,
              remark,
              processed,
          } = feeDetail;

          return {
            id,
            feeDate,
            feeType,
            amount,
            feeTypeName,
            createdAtLocalTh,
            createByFullName,
            feeDateLocalTh,
            remark,
            processed,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'calculateContractDetailFeeDetail', 'createContractDetailFeeDetail', 'updateContractDetailFeeDetail', 'deleteContractDetailFeeDetail']),
    visibility() {
      return visibility
    },
    visibilityFeeAction(row){
      return !row.processed && row.feeType === IFeeType.debtCollectionFeeCustom
    },
    async onPressedCalculate() {
      const { id: contractId } = this.$route.params;
      const { calculateContractDetailFeeDetail } = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการประมวลผล',
        text: 'คุณต้องการประมวลผลข้อมูลค่าธรรมเนียมใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await calculateContractDetailFeeDetail({
            contractId,
          })
        }
      })
    },
    async onPressedActiveAddFeeDetail() {
      const vm = this
      vm.feeDetailModal.active = true
      vm.feeDetailModal.type = 'add'
      vm.feeDetailModal.id = null
      vm.feeDetailModal.title = 'เพิ่มข้อมูลค่าธรรมเนียม';
      vm.feeDetailModal.feeDate = moment().format('DD-MM-YYYY');
      vm.feeDetailModal.feeType = IFeeType.debtCollectionFeeCustom;
      vm.feeDetailModal.amount = 0;
      vm.feeDetailModal.remark = "";
    },
    async onPressedActiveUpdateFeeDetail(row) {
      const vm = this;
      vm.feeDetailModal.active = true;
      vm.feeDetailModal.id = row.id;
      vm.feeDetailModal.type = 'update';
      vm.feeDetailModal.title = 'แก้ไขข้อมูลค่าธรรมเนียม';
      vm.feeDetailModal.feeDate = moment(row.feeDate).format('DD-MM-YYYY');
      vm.feeDetailModal.feeType = row.feeType;
      vm.feeDetailModal.amount = row.amount;
      vm.feeDetailModal.remark = row.remark;
    },
    async onPressedAcceptFeeDetailModel() {
      const vm = this
      const contractId  = this.$route.params.id;
      const {createContractDetailFeeDetail, updateContractDetailFeeDetail } = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const feeDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.feeDetailModal.feeDate.trim())
        if(vm.feeDetailModal.type === 'add') {
          await createContractDetailFeeDetail({
            contractId,
            form: {
              feeDate,
              feeType: vm.feeDetailModal.feeType,
              amount: parseFloat(vm.feeDetailModal.amount),
              remark: vm.feeDetailModal.remark,
            }
          })
        }else if(vm.feeDetailModal.type === 'update') {
          await updateContractDetailFeeDetail({
            id: vm.feeDetailModal.id,
            form: {
              feeDate,
              feeType: vm.feeDetailModal.feeType,
              amount: parseFloat(vm.feeDetailModal.amount),
              remark: vm.feeDetailModal.remark,
            }
          })
        }
        vm.feeDetailModal.active = false;
      })
    },
    async onPressedDelFeeDetail(id) {
      const vm = this
      const { deleteContractDetailFeeDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailFeeDetail({
            id,
            vm
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
